import { defineMessages } from 'react-intl';

export default defineMessages({
	title: {
		id: 'register.welcome.title',
		defaultMessage: "Ready to Begin",
	},
	qualtrics_title: {
		id: 'register.welcome.qualtrics_title',
		defaultMessage: "Please click below to start the video",
	},
	message: {
		id: 'register.welcome.message',
		defaultMessage: `We’re excited to give you an exclusive screening of {group_name}.`,
	},
	qualtrics_message: {
		id: 'register.welcome.qualtrics_message',
		defaultMessage: `We’re excited to bring you this exclusive screening. Once complete, you will return back to your survey to answer additional questions. If you have trouble watching the video, please refresh the page. If it is still not working after trying a few times, please contact Amazon customer service by clicking on the ‘Help’ link in the survey invitation email you received. If viewing on a mobile device, full screen is disabled and you are only able to access using Chrome on Android phones or Safari on iPhones.`,
	},
	verify: {
		id: 'register.welcome.verify',
		defaultMessage: `We’ll begin by verifying some information.`,
	},
	eligible: {
		id: 'register.welcome.eligible',
		defaultMessage: `Before we can begin, we just need to verify some information to be sure you're eligible to proceed.`,
	},
	match: {
		id: 'register.welcome.match',
		defaultMessage: `Nice to meet you. To begin, it would be great to get to know you better so we can match you up with screenings.`,
	},
	create_profile: {
		id: 'register.welcome.create_profile',
		defaultMessage: `We’ll begin by creating your profile`,
	},
	welcome_to_study: {
		id: 'register.welcome.welcome_to_study',
		defaultMessage: "Welcome to Your Study",
	},
	welcome_to_pilotly: {
		id: 'register.welcome.welcome_to_pilotly',
		defaultMessage: "Welcome to Pilotly",
	},
	terms_of_service: {
		id: 'register.welcome.terms_of_service',
		defaultMessage: "Terms of Use",
	},
	privacy_policy: {
		id: 'register.welcome.privacy_policy',
		defaultMessage: "Privacy Policy",
	},
	name: {
		id: 'register.welcome.name',
		defaultMessage: "name",
	},
	email_address: {
		id: 'register.welcome.email_address',
		defaultMessage: "email address",
	},
	birth_date: {
		id: 'register.welcome.birth_date',
		defaultMessage: "birth date",
	},
	birth_date_placeholder: {
		id: 'register.welcome.birth_date.placeholder',
		defaultMessage: "mm/dd/yyyy",
	},
	child_birth_date: {
		id: 'register.welcome.child_birth_date',
		defaultMessage: "child birth date",
	},
	age: {
		id: 'register.welcome.age',
		defaultMessage: "age",
	},
	consent: {
		id: 'register.welcome.consent',
		defaultMessage: "consent",
	},
	gender: {
		id: 'register.welcome.gender',
		defaultMessage: "gender",
	},
	zipcode: {
		id: 'register.welcome.zipcode',
		defaultMessage: "zipcode",
	},
	household_income: {
		id: 'register.welcome.household_income',
		defaultMessage: "household income",
	},
	ethnicity: {
		id: 'register.welcome.ethnicity',
		defaultMessage: "ethnicity",
	},
	race: {
		id: 'register.welcome.ethnicity_race',
		defaultMessage: "race",
	},
	education: {
		id: 'register.welcome.education',
		defaultMessage: "highest level of completed education",
	},
	country: {
		id: 'register.welcome.country',
		defaultMessage: "country of residence",
	},
	password: {
		id: 'register.welcome.password',
		defaultMessage: "password",
	},
	button_begin_study: {
		id: 'register.welcome.button.begin_study',
		defaultMessage: "Begin Study",
	},
	button_next: {
		id: 'register.welcome.button.next',
		defaultMessage: "Next",
	},
	button_begin_screening: {
		id: 'register.welcome.button.begin_screening',
		defaultMessage: "Begin Screening",
	},
	button_create_profile: {
		id: 'register.welcome.button.create_profile',
		defaultMessage: "Create Profile",
	},
	error_name: {
		id: 'register.form.error.name',
		defaultMessage: `Please enter your {name}`
	},
	error_full_name: {
		id: 'register.form.error.full_name',
		defaultMessage: `Please enter your full name`
	},
	error_zipcode: {
		id: 'register.form.error.zipcode',
		defaultMessage: `Please enter your {zipcode}`
	},
	error_country: {
		id: 'register.form.error.country',
		defaultMessage: `Please select your country of residence`
	},
	error_income: {
		id: 'register.form.error.income',
		defaultMessage: `Invalid Income`,
	},
	error_birth_date: {
		id: 'register.form.error.birth_date',
		defaultMessage: `Invalid Birthdate (mm/dd/yyyy)`,
	},
	error_age: {
		id: 'register.form.error.age',
		defaultMessage: `Invalid age`,
	},
	error_child_age: {
		id: 'register.form.error.child_age',
		defaultMessage: `Please enter your child's age`,
	},
	error_email_missing: {
		id: 'register.form.error.email.missing',
		defaultMessage: `Please enter an email address`,
	},
	error_email_invalid: {
		id: 'register.form.error.email.invalid',
		defaultMessage: `Please enter a valid email address`,
	},
	error_email_invalid_domain: {
		id: 'register.form.error.email.invalid_domain',
		defaultMessage: `Please enter an email with a valid domain`,
	},
	error_ethnicity_missing: {
		id: 'register.form.error.ethnicity.missing',
		defaultMessage: `Please enter an ethnicity`,
	},
	error_ethnicity_limit: {
		id: 'register.form.error.ethnicity.limit',
		defaultMessage: `Please limit selection to at most 3`,
	},
	error_password_missing: {
		id: 'register.form.error.password.missing',
		defaultMessage: `Please enter a password`,
	},
	error_password_invalid: {
		id: 'register.form.error.password.invalid',
		defaultMessage: `Please enter a password with at least 1 number, 1 capital letter, and a minimum of 8 characters`,
	},
	error_login_failed: {
		id: 'register.form.error.login.failed',
		defaultMessage: `Login Failed`,
	},
	error_login_incorrect: {
		id: 'register.form.error.login.incorrect',
		defaultMessage: `Incorrect Email or Password`,
	},
	error_register_failed: {
		id: 'register.form.error.register.failed',
		defaultMessage: `Registration Failed.`,
	},
	error_loading_user: {
		id: 'register.form.error.user.loading.failed',
		defaultMessage: `Loading user failed.`,
	},
	error_metadata_failed: {
		id: 'register.form.error.metadata.failed',
		defaultMessage: `Saving Meta data Failed.`,
	},
	error_email_in_use: {
		id: 'register.form.error.email.used',
		defaultMessage: `A user with this email already exists.`,
	},
	error_email_check_failed: {
		id: 'register.form.error.email.check',
		defaultMessage: `Email check failed.`,
	},
	error_zip_invalid: {
		id: 'register.form.error.zip.invalid',
		defaultMessage: `This zip code is not valid.`,
	},
	error_zip_check_failed: {
		id: 'register.form.error.zip.check',
		defaultMessage: `Zip Code Check Failed.`,
	},
	error_study_loading_info: {
		id: 'register.form.error.study.loading',
		defaultMessage: `There was a problem loading data for this study.`,
	},
	error_updating_video_disclaimer: {
		id: 'video-disclaimer.form.error.study.loading',
		defaultMessage: `There was a problem saving the video disclaimer for this user.`,
	},
	error_terminating_user: {
		id: 'terminate.form.error.user.terminate',
		defaultMessage: `There was a problem terminating a user.`,
	},

	agreement: {
		id: 'viewer_consent.laymens.agreement',
		defaultMessage: 'you agreed to the following'
	},
	social_media_instructions: {
		id: 'viewer_consent.laymens.social_media_instructions',
		defaultMessage: 'Do Not Post Anything'
	},
	store_content_instructions: {
		id: 'viewer_consent.laymens.store_content_instructions',
		defaultMessage: 'Do Not Store or Share Any Content'
	}
});



// WEBPACK FOOTER //
// ./src/locales/register.js